import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/components/layout/layout.component';
import { HomeComponent } from './features/authentication/components/home/home.component';
import { ShopifyAuthVerifyComponent } from './features/authentication/components/shopify-auth-verify/shopify-auth-verify.component';
import { TikTokAuthVerifyComponent } from './features/authentication/components/tiktok-auth-verify/tiktok-auth-verify.component';
import { AuthGuard } from './features/authentication/guards/auth.guard';
import { TenantOverviewComponent } from './features/tenants/components/tenant-overview/tenant-overview.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./features/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'shopify/verify',
    component: ShopifyAuthVerifyComponent,
  },
  {
    path: 'tiktok/verify',
    component: TikTokAuthVerifyComponent,
  },
  {
    path: 'client',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/clients/clients.module').then((m) => m.ClientsModule),
  },
  {
    path: 'tenant',
    canActivate: [AuthGuard],
    component: TenantOverviewComponent,
  },
  {
    path: '',
    component: HomeComponent,
  },
  { path: '**', redirectTo: 'tenant' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
